module.exports = function(object) {
  return object === void 0;
};
